// src/App.jsx
import React from "react";
import DynamicForm from "./pages/DynamicForm";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import StaticForm from "./pages/StaticForm";
import ClientForm from "./pages/ClientForm";
import DynamicFormTemplate from "./pages/DynamicFormTemplate";
import CertificadoCita from "./pages/CertificadoCita";

const App = () => (
    <Router basename="/syso-forms">
        <Routes>
            <Route path="/form-client" element={<ClientForm />} />
            <Route path="/form-experiences" element={<StaticForm />} />
            <Route path="/certificado-client/:id" element={<CertificadoCita />} />
            <Route path="/dynamic-form/:id" element={<DynamicFormTemplate />} />
            <Route path="/form/:id" element={<DynamicForm />} />
        </Routes>
    </Router>
);

export default App;